export default "__VITE_ASSET__BSeuudPI__"